import { BACKEND_API_URL } from "../config/config";
import QueryService from "../services/queryService";



export const registerUser = (payload: any) => {
    const queryService = new QueryService(BACKEND_API_URL);
    const fetchData = async () => {
        let url = `/updateOrInsertUserDetails/`;
        const data = await queryService.runQuery(url, "POST", payload);
        return data;
    }

    return fetchData().then((data) => {
        return data;
    }).catch(() => {
        console.log("Unable to register user");
    })
}
